module.exports = __webpack_public_path__ + "static/media/hk.e6716915.svg";